import { i18nReducer } from 'react-redux-i18n';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist-indexeddb-storage';
import { analyticsReducer } from 'store/app/entities/AnalyticsSlice';
import { employeesApiReducer } from 'store/app/entities/EmployeesApiSlice';
import { wbReducer } from 'store/app/entities/WbSlice';
import { ommnioSignReducer } from 'store/app/entities/OmmnioSignSlice';
import { batchReducer } from 'store/app/entities/BatchSlice';
import { otaReducer } from 'store/app/entities/OtaSlice';
import { aiConfigReducer } from 'store/app/entities/AiConfigSlice';
import { firebaseBeaconReducer } from 'utils/reduxBeaconConfig';
import auth from './auth/reducer';
import authConfig from './authConfig/reducer';
import admins from './entities/admins/reducer';
import { appDataReducer } from './entities/AppDataSlice';
import apps from './entities/apps/reducer';
import { articlesReducer } from './entities/ArticlesSlice';
import bulkMessaging from './entities/bulkMessaging/reducer';
import channels from './entities/channels/reducer';
import chatFlowEntityTypes from './entities/chatFlowEntityTypes/reducer';
import chatFlowIntegrations from './entities/chatFlowIntegrations/reducer';
import chatFlowIntents from './entities/chatFlowIntents/reducer';
import chatFlows from './entities/chatFlows/reducer';
import companies from './entities/companies/reducer';
import { cloudMirrorReducer } from './entities/CloudMirrorSlice';
import { companiesReducer } from './entities/CompaniesSlice';
import config from './entities/config';
import { contentsReducer } from './entities/ContentsSlice';
import { eSignatureProviderReducer } from './entities/ESignatureProviderSlice';
import documentFormats from './entities/documentFormats/reducer';
import employeeImports from './entities/employeeImports/reducer';
import employees from './entities/employees/reducer';
import forms from './entities/forms/reducer';
import { groupsReducer } from './entities/GroupsSlice';
import { initiativesReducer } from './entities/InitiativesSlice';
import linkPreviews from './entities/linkPreviews/reducer';
import messages from './entities/messages/reducer';
import { messagesApiReducer } from './entities/MessagesApiSlice';
import settings from './entities/settings/reducer';
import { sharedFilesReducer } from './entities/SharedFilesSlice';
import subscriptions from './entities/subscriptions/reducer';
import { teamMembershipRulesReducer } from './entities/TeamMembershipRulesSlice';

import teams from './entities/teams/reducer';
import { teamsReducer } from './entities/TeamsSlice';
import timeTrackerLog from './entities/timeTrackerLog/reducer';
import users from './entities/users/reducer';
import { usersReducer } from './entities/UsersSlice';
import ui from './ui';
import drawers from './ui/drawers';
import header from './ui/header/reducer';
import login from './ui/login/reducer';
import media from './ui/media/reducer';
import modals from './ui/modals';

const persistConfig = {
  key: 'root',
  storage: storage('ommnio'),
  version: 1,
  whitelist: [],
  migrate: () => {
    return Promise.resolve({});
  },
};

const createRootReducer = () =>
  persistReducer(
    persistConfig,
    combineReducers({
      admins,
      analytics: analyticsReducer,
      apps,
      appData: appDataReducer,
      articles: articlesReducer,
      auth,
      authConfig,
      bulkMessaging,
      channels,
      chatFlowEntityTypes,
      chatFlowIntegrations,
      chatFlowIntents,
      chatFlows,
      cloudMirror: cloudMirrorReducer,
      companies,
      companiesReducer,
      contentsReducer,
      eSignatureProviderReducer,
      wbSlice: wbReducer,
      batchReducer,
      otaReducer,
      aiConfigReducer,
      config,
      documentFormats,
      drawers,
      elements: ui,
      employeeImports,
      employees,
      employeesApi: employeesApiReducer,
      firebaseBeaconReducer,
      forms,
      groups: groupsReducer,
      initiativesApi: initiativesReducer,
      header,
      i18n: i18nReducer,
      linkPreviews,
      login,
      media,
      messages,
      messagesApi: messagesApiReducer,
      modals,
      ommnioSign: ommnioSignReducer,
      settings,
      sharedFiles: sharedFilesReducer,
      subscriptions,
      usersReducer,
      teamMembershipRules: teamMembershipRulesReducer,
      teams,
      teamsReducer,
      timeTrackerLog,
      users,
    }),
  );

export default createRootReducer;
